import ufeApi from 'services/api/ufeApi';
import RCPSCookies from 'utils/RCPSCookies';

const AUTH_URL = '/api/auth/v1/validatePasswordToken';
const SDN_URL = '/gway/v1/dotcom/auth/v1/validatePasswordToken';

// https://jira.sephora.com/wiki/display/ILLUMINATE/Validate+Password+Token+API

function validatePasswordToken(securityToken, options = {}) {
    const normalizedOptions = typeof options === 'boolean' ? { isStoreBIMemberEmailVerification: options } : options;
    const { isStoreBIMemberEmailVerification = false, pk = false } = normalizedOptions;
    let URL = AUTH_URL;
    const headers = {
        'Content-type': 'application/json',
        'x-requested-source': 'web'
    };
    const payload = { securityToken, isStoreBIMemberEmailVerification };

    if (pk) {
        payload.pk = true;
    }

    if (RCPSCookies.isRCPSAuthEnabled()) {
        URL = SDN_URL;
    }

    return ufeApi
        .makeRequest(URL, {
            method: 'POST',
            body: JSON.stringify(payload),
            headers
        })
        .then(data => (data.errorCode || data.errors ? Promise.reject(data) : data));
}

export default validatePasswordToken;
